import carol1 from './carol1.mp3';
import carol2 from './carol2.mp3';
import carol3 from './carol2.mp3';

const CAROL_LIST = [carol1, carol2, carol3];

export default CAROL_LIST;
